import { View, TextInput, Platform } from 'react-native';
import { Text } from '@/components/Text';
import colors from '@/config/colors';

export const ConfirmDeleteAccount = ({
  onTextChange,
}: {
  onTextChange: (value: string) => void;
}) => {
  return (
    <View className="w-full p-4">
      <Text className="text-xl mb-2">
        Schreiben Sie
        <Text className="font-semibold"> &quot;Löschen&quot; </Text>
        in das Eingabefeld, um die Löschung Ihres Accounts zu bestätigen.
      </Text>
      <View className="w-full h-14">
        <TextInput
          className="w-1/2 h-full border rounded-md border-slate-200 bg-slate-50 px-2 text-lg leading-none"
          placeholder="Löschen"
          placeholderTextColor={'gray'}
          onChangeText={onTextChange}
          autoComplete="off"
          style={{
            ...(Platform.OS === 'ios'
              ? { lineHeight: 0, color: colors.newUI.therapist.textBlue100 }
              : { color: colors.newUI.therapist.textBlue100 }),
          }}
        />
      </View>
    </View>
  );
};
